import StringUtils from "@utils/string.utils";
import { get } from "lodash";

export default {
  /**
   * This function sorts a list of objects according to the sorting order of the list of property keys, either in ascending or descending order.
   * @param {*} data List of objects
   * @param {*} config List of property keys and ascending order boolean for multi layer sorting (e.g [{field: "student.name", asc: true}, {field: "section.attempt.timestamp", asc: false}])
   * @return List of sorted objects
   */
  sortObjects(data, config) {
    if (!data || !data.length) {
      return [];
    }
    if (!config || !config.length) {
      return data;
    }

    const sortedList = data.sort((a, b) => {
      let compareResult = 0;
      for (const map of config) {
        // Continue to compare against next key if value of current key is the same
        if (get(a, map.field) === get(b, map.field)) continue;

        // Check if both values are not strings, then compare as raw values
        if (!StringUtils.isString(get(a, map.field)) && !StringUtils.isString(get(b, map.field))) {
          if (map.asc) {
            compareResult = get(a, map.field) > get(b, map.field) ? 1 : -1;
          } else {
            compareResult = get(b, map.field) > get(a, map.field) ? 1 : -1;
          }
        } else {
          // If any of the values is string, treat both as string
          const collator = StringUtils.getStringCollator();
          compareResult = map.asc
            ? collator.compare(get(a, map.field), get(b, map.field))
            : collator.compare(get(b, map.field), get(a, map.field));
        }
        break;
      }
      return compareResult;
    });

    return sortedList;
  },
};
